import { Controller } from "@hotwired/stimulus";
import zxcvbn from "zxcvbn";

// Connects to data-controller="password-strength"
export default class extends Controller {
  static targets = ["password", "feedback"];

  calculate() {
    const classList =
      "mt-1 text-gray-500 text-sm/snug before:inline-block before:rounded-sm before:size-2 before:mr-2";

    if (this.passwordTarget.value !== "") {
      const result = zxcvbn(this.passwordTarget.value);

      if (result.score === 0) {
        this.feedbackTarget.className = `${classList} before:bg-red-500`;
        this.feedbackTarget.innerText = "Weak";
      } else if (result.score === 1) {
        this.feedbackTarget.className = `${classList} before:bg-orange-500`;
        this.feedbackTarget.innerText = "Weak";
      } else if (result.score === 2) {
        this.feedbackTarget.className = `${classList} before:bg-yellow-500`;
        this.feedbackTarget.innerText = "Fair";
      } else if (result.score === 3) {
        this.feedbackTarget.className = `${classList} before:bg-green-500`;
        this.feedbackTarget.innerText = "Good";
      } else {
        this.feedbackTarget.className = `${classList} before:bg-green-500`;
        this.feedbackTarget.innerText = "Excellent";
      }
      if (result.feedback.warning) {
        this.feedbackTarget.innerText = result.feedback.warning;
      }
    } else {
      this.feedbackTarget.className = `${classList} before:bg-gray-500`;
      this.feedbackTarget.innerText = "Must be at least 8 characters long";
    }
  }
}
